import React from 'react';
import './ShippingPolicyPage.css';

const ShippingPolicyPage = () => {
  return (
    <div className="policy-page">
      <div className="policy-container">
        <div className="policy-header">
          <h1>Shipping Policy — TRYON</h1>
          <p className="last-updated">Last Updated: 29/12/2025</p>
        </div>

        <div className="shipping-intro">
          <div className="intro-icon">
            <svg width="60" height="60" viewBox="0 0 24 24" fill="none" stroke="white" strokeWidth="2">
              <rect x="1" y="3" width="15" height="13"/>
              <polygon points="16 8 20 8 23 11 23 16 16 16 16 8"/>
              <circle cx="5.5" cy="18.5" r="2.5"/>
              <circle cx="18.5" cy="18.5" r="2.5"/>
            </svg>
          </div>
          <h2>Fast & Reliable Delivery</h2>
          <p>We ensure your custom-printed T-shirts reach you safely and on time!</p>
        </div>

        <div className="policy-section">
          <h2>1. Order Processing Time</h2>
          <p>Orders are processed within <strong>1–3 business days</strong> after confirmation.</p>
        </div>

        <div className="policy-section">
          <h2>2. Delivery Time</h2>
          <div className="delivery-timeline">
            <div className="timeline-item">
              <div className="timeline-icon">📦</div>
              <h3>Estimated Delivery</h3>
              <p className="highlight">7–15 business days</p>
              <p className="sub-text">after dispatch</p>
            </div>
            <div className="timeline-arrow">→</div>
            <div className="timeline-item">
              <div className="timeline-icon">📍</div>
              <h3>Location Based</h3>
              <p>Delivery time may vary based on location and external logistic factors.</p>
            </div>
          </div>
        </div>

        <div className="policy-section">
          <h2>3. Shipping Charges</h2>
          <div className="info-box">
            <ul>
              <li>Shipping charges will be displayed at checkout before order completion.</li>
              <li>Additional COD fee may be applied (if Cash on Delivery option is selected).</li>
            </ul>
          </div>
        </div>

        <div className="policy-section">
          <h2>4. Tracking Information</h2>
          <div className="tracking-box">
            <div className="tracking-icon">
              <svg width="50" height="50" viewBox="0 0 24 24" fill="none" stroke="#667eea" strokeWidth="2">
                <path d="M21 10c0 7-9 13-9 13s-9-6-9-13a9 9 0 0118 0z"/>
                <circle cx="12" cy="10" r="3"/>
              </svg>
            </div>
            <div>
              <h3>Real-Time Tracking</h3>
              <p>Once shipped, customers will receive tracking details via <strong>SMS/Email/WhatsApp</strong>.</p>
            </div>
          </div>
        </div>

        <div className="policy-section">
          <h2>5. Delivery Attempts</h2>
          <div className="attempts-grid">
            <div className="attempt-card">
              <div className="attempt-number">2-3</div>
              <h3>Delivery Attempts</h3>
              <p>Courier may attempt delivery up to 2–3 times.</p>
            </div>
            <div className="attempt-card warning">
              <div className="attempt-icon">⚠️</div>
              <h3>Failed Delivery</h3>
              <p>Failure to receive may result in the order being returned to TRYON and a re-shipping fee may apply.</p>
            </div>
          </div>
        </div>

        <div className="policy-section">
          <h2>6. Address Accuracy</h2>
          <div className="warning-box">
            <div className="warning-icon">
              <svg width="40" height="40" viewBox="0 0 24 24" fill="none" stroke="#ff6b6b" strokeWidth="2">
                <path d="M10.29 3.86L1.82 18a2 2 0 001.71 3h16.94a2 2 0 001.71-3L13.71 3.86a2 2 0 00-3.42 0z"/>
                <line x1="12" y1="9" x2="12" y2="13"/>
                <line x1="12" y1="17" x2="12.01" y2="17"/>
              </svg>
            </div>
            <div>
              <h3>Important Notice</h3>
              <ul>
                <li>Customers must ensure correct delivery details.</li>
                <li>TRYON is not responsible for lost shipments due to incorrect addresses provided at checkout.</li>
              </ul>
            </div>
          </div>
        </div>

        <div className="contact-section">
          <h2>Need Help with Your Shipment?</h2>
          <p>Our support team is here to assist you with any shipping queries!</p>
          <div className="contact-buttons">
            <a href="mailto:tyon.wear02@gmail.com" className="contact-btn">
              <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                <path d="M3 8l7.89 5.26a2 2 0 002.22 0L21 8M5 19h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z"/>
              </svg>
              tyon.wear02@gmail.com
            </a>
            <a href="tel:+919265490049" className="contact-btn">
              <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                <path d="M22 16.92v3a2 2 0 01-2.18 2 19.79 19.79 0 01-8.63-3.07 19.5 19.5 0 01-6-6 19.79 19.79 0 01-3.07-8.67A2 2 0 014.11 2h3a2 2 0 012 1.72 12.84 12.84 0 00.7 2.81 2 2 0 01-.45 2.11L8.09 9.91a16 16 0 006 6l1.27-1.27a2 2 0 012.11-.45 12.84 12.84 0 002.81.7A2 2 0 0122 16.92z"/>
              </svg>
              +91 9265490049
            </a>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ShippingPolicyPage;
